import { useState, useEffect } from "react";


export const useSubscriptionLimits = () => {
    const [limits, setLimits] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLimits = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('https://www.ia-schedule.com:4139/api/roster/limits', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch limits');
            }

            const data = await response.json();
            setLimits(data);
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLimits();
    }, []);

    return { limits, loading, error, refetchLimits: fetchLimits };
};


export const useExportRestrictions = (isProUser) => {
    const handleExport = async (format, exportFunction) => {
        if (!isProUser && format !== 'pdf') {
            return {
                isAllowed: false,
                error: {
                    title: 'Export Restricted',
                    description: 'Upgrade to Professional plan to export in other formats!',
                    variant: 'warning'
                }
            };
        }

        return { isAllowed: true, result: await exportFunction() };
    };

    return { handleExport };
};